module.exports = __webpack_public_path__ + "media/images/lamp/yellow-656be9a2d36c1bb2457e2a3b41fb1a6d.png";